export default {
  postCodeValid: /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) {0,1}[0-9][A-Za-z]{2})$/i,
  nationalInsuranceValid: /^(?!BG)(?!GB)(?!NK)(?!KN)(?!TN)(?!NT)(?!ZZ)(?:[A-CEGHJ-PR-TW-Z][A-CEGHJ-NPR-TW-Z])(?:\s*\d\s*){6}([A-D]|\s)$/i,
  contactNoValid: /^((\(?0\d{4}\)?\s?\d{3}\s?\d{3})|(\(?0\d{3}\)?\s?\d{3}\s?\d{4})|(\(?0\d{2}\)?\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/,
  hasNonLetters: /[^a-zA-Z]+/,
  lettersAndSpaces: /^[a-zA-Z\s]*$/,
  lettersSpacesHyphen: /^[A-Za-z\s-']+$/,
  leadUUid: /(\?|&)lead_id=[\w|\d]{8}-([\w|\d]{4}-){3}[\w|\d]{12}/
};
